import { ReactNode } from 'react';
import styles from './ServiceIconShell.module.scss';
import { ServiceIconSize } from '../ServiceIcon';
import { ServiceIconConfig } from '../ServiceIcon/constants';

type ServiceIconShellProps = {
  /** The size of ServiceIconShell component to render. */
  size: ServiceIconSize;
  /** Applies a shadow to the ServiceIconShell. */
  hasShadow?: boolean;
  /**
   * Controls the presence/absence of the border.
   * It is recommended that a borderless ServiceIcon be contained in a larger, bordered container.
   */
  hasBorder?: boolean;
  /** The children to render inside of the `ServiceIconShell` component. */
  children?: ReactNode;
  /** Changes the background color to white (#fff). */
  hasWhiteBackground?: boolean;
};

/**
 * Renders the shell around an icon or number, representing one or more services.
 *
 * **This component isn't used on its own, but is exposed so that other components that are imperative to keep stylistically synced can use it.**
 */
export const ServiceIconShell = ({
  children,
  hasBorder = true,
  hasShadow = false,
  hasWhiteBackground = false,
  size,
}: ServiceIconShellProps) => {
  return (
    <span
      className={styles.serviceIcon}
      data-border={hasBorder}
      data-shadow={hasShadow}
      data-background={hasWhiteBackground ? 'white' : 'default'}
      data-size={size}
      data-zds
      data-testid="ServiceIconShell"
      style={{
        '--width': ServiceIconConfig[size].width,
        '--height': ServiceIconConfig[size].width,
        '--border-radius': ServiceIconConfig[size].borderRadius,
      }}
    >
      {children}
    </span>
  );
};
